import { Stack } from '@fluentui/react/lib/Stack';
import React from 'react';
import { CheckList } from '../CheckList/CheckList';
import { BaseComponentProps } from '../types';

export const TimeRangePicker = (props: BaseComponentProps): JSX.Element => {
  const { inputs, onSubmit } = props;
  return (
    <Stack>
      <CheckList
        title="Time"
        editable={false}
        inputs={inputs}
        onSubmit={onSubmit}
      />
    </Stack>
  );
};
